export default __webpack_public_path__ + "static/media/boat-middle.ecc014ee.svg";